<template>
  <div class="smb-sales_container">
    <div class="smb-sales_container_title">
      Partner Contract Info
    </div>
    <div class="smb-sales_container_content" v-if="isDetail">
      <el-row class="smb-sales_mb-40">
        <el-col :span="12">
          <div class="smb-sales_label">Partner Type</div>
          <div class="smb-sales_value">
            {{ detailData.partnerTypeName || "-" }}
          </div>
        </el-col>
        <el-col :span="12" v-if="detailData.partnerType !== 'VAD'">
          <div class="smb-sales_label">Affiliated VAD</div>
          <div class="smb-sales_value">
            {{ detailData.parentCompanyName || "-" }}
          </div>
        </el-col>
        <el-col :span="12" v-else>
          <div class="smb-sales_label">Contract Expiry Date</div>
          <div class="smb-sales_value">
            {{
              detailData.contractValidity
                ? dayjs(detailData.contractValidity).format("YYYY-MM-DD")
                : "-"
            }}
          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40">
        <el-col :span="12" v-if="detailData.partnerType !== 'VAD'">
          <div class="smb-sales_label">Contract Expiry Date</div>
          <div class="smb-sales_value">
            {{
              detailData.contractValidity
                ? dayjs(detailData.contractValidity).format("YYYY-MM-DD")
                : "-"
            }}
          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Contract Start Date</div>
          <div class="smb-sales_value">
            {{
              detailData.contractStartDate
                ? dayjs(detailData.contractStartDate).format("YYYY-MM-DD")
                : "-"
            }}
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="smb-sales_container_content" v-if="isSeniorEditApprove">
      <el-row class="smb-sales_mb-40" :gutter="20">
        <el-col :span="12">
          <div class="smb-sales_label">Partner Type</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('partnerTypeName')">
              <div class="new-value">
                {{ detailData['partnerTypeName'] }}
              </div>
              <div class="old-value">{{ oldEditDetail['partnerTypeName'] ? `(${oldEditDetail['partnerTypeName']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData['partnerTypeName'] || "-" }}
            </template>
          </div>
        </el-col>
        <el-col :span="12" v-if="detailData['partnerType'] !== 'VAD'">
          <div class="smb-sales_label">Affiliated VAD</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('parentCompanyName')">
              <div class="new-value">
                {{ detailData['parentCompanyName'] }}
              </div>
              <div class="old-value">{{ oldEditDetail['parentCompanyName'] ? `(${oldEditDetail['parentCompanyName']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData['parentCompanyName'] || "-" }}
            </template>

          </div>
        </el-col>
        <el-col :span="12" v-else>
          <div class="smb-sales_label">Contract Expiry Date</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('contractValidity')">
              <div class="new-value">{{ formatDate(detailData['contractValidity']) }}</div>
              <div class="old-value"> {{ oldEditDetail.contractValidity ? `(${ formatDate(getNum(oldEditDetail.contractValidity)) })` : void 0 }}</div>
            </div>
            <template v-else>
              {{ formatDate(detailData['contractValidity']) }}
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40" :gutter="20">
        <el-col :span="12" v-if="detailData['partnerType'] !== 'VAD'">
          <div class="smb-sales_label">Contract Expiry Date</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('contractValidity')">
              <div class="new-value">{{ formatDate(detailData['contractValidity']) }}</div>
              <div class="old-value"> {{ oldEditDetail.contractValidity ? `(${ formatDate(getNum(oldEditDetail.contractValidity)) })` : void 0 }}</div>
            </div>
            <template v-else>
              {{ formatDate(detailData['contractValidity']) }}
            </template>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Contract Start Date</div>
          <div class="smb-sales_value">

            <div v-if="oldEditDetail.hasOwnProperty('contractStartDate')">
              <div class="new-value">{{ formatDate(detailData['contractStartDate']) }}</div>
              <div class="old-value"> {{ oldEditDetail['contractStartDate'] ? `(${ formatDate(oldEditDetail['contractStartDate']) })` : void 0 }}</div>
            </div>
            <template v-else>
              {{ formatDate(detailData['contractStartDate']) }}
            </template>
          </div>
        </el-col>
      </el-row>
    </div>
    <div
      class="smb-sales_container_content"
      v-if="isApply || isEdit || isRenew || isResubmit"
    >
      <el-form
        ref="form"
        label-position="top"
        :model="formData"
        :rules="rules"
        :disabled="isEdit && !isSenior"
      >
        <div class="smb-sales_grid grid-1x2 gap_80">
          <el-form-item prop="partnerType">
            <template #label>
              <div class="smbsales-label_required">
                Partner Type
              </div>
            </template>
            <el-select
              v-model="formData.partnerType"
              @change="handlePartnerTypeChange"
              :disabled="(isResubmit && workflowType !== 'smbSeniorEdit')"
            >
              <el-option
                v-for="partnerType in partnerTypeList"
                :label="partnerType.name"
                :value="partnerType.code"
                :key="partnerType.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="contractValidity">
            <template #label>
              <div class="smbsales-label_required">
                Contract Expiry Date
              </div>
            </template>
            <el-date-picker
              v-model="formData.contractValidity"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :picker-options="{
                disabledDate
              }"
            />
          </el-form-item>
        </div>
        <div class="smb-sales_grid grid-1x2 gap_80">
          <el-form-item prop="contractStartDate">
              <template #label>
                <div class="smbsales-label_required">
                  Contract Start Date
                </div>
              </template>
              <el-date-picker
                v-model="formData.contractStartDate"
                type="date"
                placeholder="Select date"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </el-form-item>
        </div>
        <div
          class="smb-sales_grid grid-1x2 gap_80"
          v-if="formData.partnerType !== 'VAD'"
        >
          <el-form-item prop="parentCompanyCode">
            <template #label>
              <div class="smbsales-label_required">
                Affiliated VAD
              </div>
            </template>
            <el-select
              v-model="formData.parentCompanyCode"
              filterable
              clearable
              remote
              :remote-method="searchVADType"
              @change="handleVADTypeChange"
            >
              <el-option
                v-for="(item, index) in vadTypeList"
                :key="item.companyCode + index"
                :label="item.companyName"
                :value="item.companyCode"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import {getPartnerType, getVadList} from "../../../api/international";
import dayjs from "dayjs";
import API from "../../../api";
import eventBus from "../../../utils/eventBus";
import {formatDate} from "../../../utils";
import {getNum} from "../../../utils/upload";

export default {
  name: "partnerContractInfo",
  props: {
    // 编辑类型 基础 base 或者 高级senior 默认基础
    mode: {
      type: String,
      default: "base"
    },
    // 操作类型 申请 apply, 编辑 edit, 审批 approve， 默认申请
    type: {
      type: String,
      default: "apply"
    },
    isApply: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: () => ({})
    },
    isRenew: {
      type: Boolean,
      default: false
    },
    isResubmit: {
      type: Boolean,
      default: false
    },
    //是否是高级编辑审批页面
    isSeniorEditApprove: {
      type: Boolean,
      default: false
    },
    // 编辑修改后的数据
    oldEditDetail: {
      type: Object,
      default: () => ({})
    },
    workflowType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {
        // 合作伙伴类型
        partnerType: "",
        partnerTypeName: "",
        // 合同到期日期
        contractValidity: "",
        contractStartDate: void 0,
        // 上级渠道id
        parentCompanyCode: "",
        parentCompanyName: ""
      },
      vadTypeList: [], // AffiliatedVAD 选择数据源
      partnerTypeList: [], // PartnerType选择数据源
      pickerOptions:{
        disabledDate: this.disabledData,
      }
    };
  },
  computed: {
    ...mapState("smbSales", ["partnerContractInfo", "selectCountryAndRegion"]),
    // 规则
    rules() {
      return this.isDetail
        ? {}
        : {
            partnerType: [
              {
                required: true,
                message: "please select partnerType",
                trigger: ["change"]
              }
            ],
            contractValidity: [
              {
                required: true,
                message: "please select contractValidity",
                trigger: ["change"]
              }
            ],
            contractStartDate: [
              {
                required: true,
                message: "please select contractStartDate",
                trigger: ["change"]
              }
            ],
            parentCompanyCode: [
              {
                required: true,
                message: "please select parentCompanyCode",
                trigger: ["change"]
              }
            ]
          };
    },
    // 是否是管理或者是助理
    isSenior() {
      return this.mode === 'senior'
    }
  },
  watch: {
    // 监听formData， 实时更新store的数据
    formData: {
      handler(nextFormData) {
        this.SET_PARTNER_CONTRACT_INFO(
          JSON.parse(JSON.stringify(nextFormData))
        );
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getNum,
    formatDate,
    dayjs,
    ...mapMutations("smbSales", ["SET_PARTNER_CONTRACT_INFO"]),
    searchVADType(searchValue) {
      let country = this.selectCountryAndRegion.country;
      console.log(country);
      let params = {
        companyName: searchValue,
        countryCode: country,
        documentId: this.$route.query.documentId || void 0
      }
      getVadList(params)
        .then(res => {
          let { status, data } = res
          if (Number(status) === 200) {
            this.vadTypeList = data || []
            // 没搜索出来清空值 code 和 name ,便于 编辑或者续签的时候 防止选择到过期的
            if (data && data.length < 1) {
              this.formData.parentCompanyCode = ''
              this.formData.parentCompanyName = ''
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 获取全部的渠道类型
    fetchAllPartnerType(callback) {
      getPartnerType(1).then(response => {
        let { status, data } = response;
        if (Number(status) === 200) {
          this.partnerTypeList = data;
          callback && callback();
        }
      });
    },
    // 当渠道类型更改的时候
    handlePartnerTypeChange(code) {
      const partnerTypeInfo = this.partnerTypeList.find(
        item => item.code === code
      );
      this.formData.partnerTypeName = partnerTypeInfo.name;
      // 如果是vad的时候 清空所属vad
      if (code === "VAD") {
        this.formData.parentCompanyCode = "";
        this.formData.parentCompanyName = "";
      }
    },

    // 设置渠道类型为路由传过来的type
    setPartnerType() {
      if (this.$route.query.partnertype) {
        this.formData.partnerType = this.$route.query.partnertype;
      }
    },

    // 当所属VAD更改的时候
    handleVADTypeChange(code) {
      const vadTypeInfo = this.vadTypeList.find(
        item => item.companyCode === code
      );
      this.formData.parentCompanyName = vadTypeInfo.companyName;
    },
    // 设置formData
    setFormData(formData) {
      let formDataCopy = JSON.parse(JSON.stringify(formData));
      this.formData = formDataCopy;
      if (formDataCopy.partnerType === "VAD") {
        this.vadTypeList = [];
        this.formData.parentCompanyCode = ''
        this.formData.parentCompanyName = ''
      } else {
        this.searchVADType(formData.parentCompanyName);
      }
    },
    // 获取formData
    getFormData() {
      if (this.isDetail) {
        return;
      }
      let isPass = false;
      this.$refs.form.validate(isSuccess => {
        isPass = isSuccess;
      });
      if (isPass) {
        return JSON.parse(JSON.stringify(this.formData));
      } else {
        return isPass;
      }
    },
    disabledData(time) {
      if(time){
        // var begin=new Date(this.formData.contractValidity.replace(/-/g,"/"));
        //  var end=new Date(time.replace(/-/g,"/"));
        // console.log(time);
          if((Date.parse(new Date(this.formData.contractValidity)))-(Date.parse(new Date(time)))>0){
        // console.log((Date.parse(new Date(this.formData.contractValidity))), (Date.parse(new Date(time))))
               return false;
           }else{
             return true;
            }
         }
      

    },
    disabledDate(time) {
      let nowData = dayjs().format("YYYY-MM-DD");
      let currentDate = dayjs(time).format("YYYY-MM-DD");
      // 今天之前的日期不可选
      if (dayjs(currentDate).isBefore(dayjs(nowData))) {
        return true;
      }
      // 如果今天不是12月， 那么不可选择第二年第一天之后的日期
      if (dayjs(nowData).month() !== 11) {
        if (
          dayjs(currentDate).isAfter(dayjs(dayjs(nowData).format("YYYY-12-31")))
        ) {
          return true;
        }
      } else {
        // 如果今天是12月， 那么不可选择第二年最后一天的之后的日期
        if (
          dayjs(currentDate).isAfter(
            dayjs(
              dayjs(nowData)
                .add(1, "year")
                .format("YYYY-12-31")
            )
          )
        ) {
          return true;
        }
      }
    },
    disabledDate(time) {
      let nowData = dayjs().format("YYYY-MM-DD");
      let currentDate = dayjs(time).format("YYYY-MM-DD");
      // 今天之前的日期不可选
      if (dayjs(currentDate).isBefore(dayjs(nowData))) {
        return true;
      }
      // 如果今天不是12月， 那么不可选择第二年第一天之后的日期
      if (dayjs(nowData).month() !== 11) {
        if (
          dayjs(currentDate).isAfter(dayjs(dayjs(nowData).format("YYYY-12-31")))
        ) {
          return true;
        }
      } else {
        // 如果今天是12月， 那么不可选择第二年最后一天的之后的日期
        if (
          dayjs(currentDate).isAfter(
            dayjs(
              dayjs(nowData)
                .add(1, "year")
                .format("YYYY-12-31")
            )
          )
        ) {
          return true;
        }
      }
    },
    clearAffiliatedVAD() {
      this.formData.parentCompanyCode = "";
      this.formData.parentCompanyName = "";
      this.vadTypeList = []
    }
  },
  mounted() {
    if (!this.isDetail) {
      this.formData.contractValidity = new Date().getFullYear() + "-12-31";
      this.fetchAllPartnerType(this.setPartnerType);
    }
    window.dayjs = dayjs
    eventBus.$on('onSelectCountryChange', this.clearAffiliatedVAD);
  }
};
</script>

<style scoped>
/deep/ .el-input__icon {
  line-height: 32px;
}

/deep/ .el-date-editor {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/smbSales/components/partnerContractInfo.vue